import { useCallback } from "react";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";

import { Dispatch, GetState } from "common/types/redux";

import { isSchoolTeacher } from "features/user";
import { ROUTES } from "routing/routes";

export default function useRedirectOnSignInCallback(
  redirectAuthenticatedUserTo: string | null | undefined
) {
  const history = useHistory();

  const dispatch = useDispatch();

  return useCallback(() => {
    dispatch(redirectUserOnSignIn(redirectAuthenticatedUserTo, history));
  }, [dispatch, history, redirectAuthenticatedUserTo]);
}

function redirectUserOnSignIn(redirectAuthenticatedUserTo: any, history: any) {
  return function (dispatch: Dispatch, getState: GetState) {
    const state = getState();

    if (isSchoolTeacher(state)) {
      const teacherRedirectLink =
        redirectAuthenticatedUserTo || ROUTES.TEACHER.buildPath({});

      history.push(teacherRedirectLink);
    } else {
      const studentRedirectLink = redirectAuthenticatedUserTo || "/";
      history.push(studentRedirectLink);
    }
  };
}
